import * as React from "react";
import { useTranslation } from "react-i18next";

import LicensesTable from "./LicensesTable";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { LICENSES_ROUTE } from "components/router/Routes";
import { useTableRefresh } from "utils/useTableRefresh";

export default function AllLicensesView(): JSX.Element {
    const { t } = useTranslation();
    const { refreshCount, onHandleRefresh } = useTableRefresh();

    return (
        <ApplicationLayout
            viewTitle={t("Licenses.licenses")}
            view={<LicensesTable own={false} refreshCount={refreshCount} />}
            mainRoute={LICENSES_ROUTE}
            enableRefresh
            onHandleRefresh={onHandleRefresh}
        />
    );
}
